module.exports = __webpack_public_path__ + "img/risks-high-blood-pressure.31c2b79d.svg";